import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { RouterModule } from '@angular/router';


@Component({
    selector: 'app-video-card',
    templateUrl: './video-card.component.html',
    styleUrls: ['./video-card.component.scss'],
    imports: [RouterModule,CommonModule]
})
export class VideoCardComponent implements OnInit {

  @Input() video:any;
  @Input() number:any = "";

  // constructor(public bps:BreakpointService, public globals:Globals) { }
  constructor() { }

  ngOnInit(): void {
    // if(this.globals.webp)
    // {
      if (this.video.imageUrl.indexOf('JS0C-aJ-bAU/mqdefault') < 0){
        if(this.video.url == null){ //Mike A: search results don't yet support webp?
          this.video.imageUrl = this.video.imageUrl.replace(".jpg",".webp").replace("256x144", "177x100");
        }
      }
   // }
  }

}
